import styled, { createGlobalStyle } from 'styled-components';

import { HEADER_HEIGHT, SIDEBAR_WIDTH } from '../Header';

export const SIDEBAR_BG = '#2f3f60';

export const RedocLayoutOverrides = createGlobalStyle`
  .api-content {
    padding-top: ${HEADER_HEIGHT}px !important;
  }

  .menu-content {
    top: 0 !important;
    height: 100vh !important;
    padding-top: ${HEADER_HEIGHT}px !important;
  }

  //remove search box
  .menu-content > div:has(input) {
    display: none !important;
  }

  .react-tabs__tab-panel {
    border-radius: 8px;
  }

  .api-content td table {
    table-layout: fixed;
    width: 100%;
  }

  .api-content td:has(table) {
    overflow-x: auto;
  }

  .api-content td table td[kind='field'] {
    width: 35%;
    white-space: normal;
  }

  .api-content td table td[kind='field'] > span.property-name {
    word-break: break-all;
  }

  /* Enum description tables — only nested tables (inside a schema property cell) */
  .api-content td table {
    border-radius: 8px;
    overflow: hidden;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .api-content td table td,
  .api-content td table th {
    font-size: 12px;
  }

  .api-content td table tr:first-child th:first-child { border-top-left-radius: 8px; }
  .api-content td table tr:first-child th:last-child  { border-top-right-radius: 8px; }
  .api-content td table tr:last-child  td:first-child { border-bottom-left-radius: 8px; }
  .api-content td table tr:last-child  td:last-child  { border-bottom-right-radius: 8px; }
`;

export const SidebarHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${SIDEBAR_WIDTH}px;
  height: ${HEADER_HEIGHT}px;
  z-index: 1201;
  background-color: ${SIDEBAR_BG};
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 12px;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const LogoIconBox = styled.div`
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 8px;
`;

export const LogoImage = styled.img`
  height: 32px;
`;

export const LogoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoTitle = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: #f1f5f9;
`;

export const LogoSubtitle = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: #94a3b8;
`;
